import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const benefits = ['Rutinas simples', 'Hábitos saludables', 'Motivación real', 'Alimentación inteligente', 'Disciplina', 'Bienestar mental', 'Energía diaria', 'Organización', 'Constancia', 'Transformación física y mental'];
export function SystemIntro() {
  return <section className="py-24 px-4 bg-black border-y border-dark-border relative overflow-hidden" data-id="element-150">
      <div className="absolute inset-0 z-0 opacity-20" data-id="element-151">
        <img src="https://images.unsplash.com/photo-1571019614242-c5c5dee9f50b?w=1400&q=60&auto=format&fit=crop" alt="Fondo de entrenamiento" loading="lazy" decoding="async" className="w-full h-full object-cover" data-id="element-152" />
        <div className="absolute inset-0 bg-gradient-to-t from-black via-black/80 to-black" data-id="element-153" />
      </div>

      <div className="max-w-5xl mx-auto relative z-10 text-center" data-id="element-154">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-155">
          <h3 className="text-brand font-bold tracking-widest uppercase mb-4" data-id="element-156">
            SISTEMA N°1 PARA TRANSFORMARTE DESDE CASA
          </h3>
          <h2 className="text-6xl md:text-8xl font-display uppercase text-white mb-4" data-id="element-157">
            Entrena en Casa™
          </h2>
          <p className="text-2xl md:text-3xl font-display text-gray-300 mb-12 uppercase tracking-wide" data-id="element-158">
            Sistema Completo · 6 Tomos + 3 Bonus · Todo Resuelto
          </p>

          <div className="flex flex-wrap justify-center gap-3 mb-12" data-id="element-159">
            {benefits.map((benefit, i) => <motion.div key={i} initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.05
          }} className="flex items-center gap-2 bg-dark-card/80 backdrop-blur border border-dark-border px-4 py-2 rounded-full" data-id="element-160">
                <CheckCircle2 className="w-4 h-4 text-brand" data-id="element-161" />
                <span className="text-sm font-medium text-gray-200" data-id="element-162">
                  {benefit}
                </span>
              </motion.div>)}
          </div>

          <p className="text-xl text-brand font-medium" data-id="element-163">
            Funciona desde hoy en tu casa, patio o habitación.
          </p>
        </motion.div>
      </div>
    </section>;
}